import { action, actionOn, thunk } from 'easy-peasy';
import axios from '../services/axios';

const packagesInitialState = {
    allPackages: [],
    isFetchingAllPackages: false,
    isUpdateNecessary: false,
    initialFetchDone: false,
    packageById: null,
    isFetchingOnePackage: false,
}

const packages = {
    ...packagesInitialState,

    onGlobalResetCalled: actionOn(
        (actions, storeActions) => [
            storeActions.resetStore.performReset,
        ],
        (state, target) => {
            const [performReset] = target.resolvedTargets;

            if (target.type === performReset) {
                ({
                    allPackages: state.allPackages,
                    isFetchingAllPackages: state.isFetchingAllPackages,
                    isUpdateNecessary: state.isUpdateNecessary,
                    initialFetchDone: state.initialFetchDone,
                    packageById: state.packageById,
                    isFetchingOnePackage: state.isFetchingOnePackage
                } = packagesInitialState);
            }
        }
    ),

    setInitialFetchDone: action((state, payload) => {
        state.initialFetchDone = payload;
    }),

    setIsUpdateNecessary: action((state, payload) => {
        state.isUpdateNecessary = payload;
    }),

    setAllPackages: action((state, payload) => {
        state.allPackages = payload;
    }),

    setIsFetchingAllPackages: action((state, payload) => {
        state.isFetchingAllPackages = payload;
    }),

    fetchPackages: thunk((actions, payload, helpers) => {
        const { isFetchingAllPackages, isUpdateNecessary } = helpers.getState();
        const { apiData: { ACTIONS } } = helpers.getStoreState().actionSlugs;

        const getUrl = ACTIONS?.packages?.readAll?.url;

        if (!isFetchingAllPackages && isUpdateNecessary) {
            actions.setIsFetchingAllPackages(true);
            return axios.get(getUrl)
                .then(data => {
                    actions.setAllPackages(data);
                    actions.setIsUpdateNecessary(packagesInitialState.isUpdateNecessary);
                    return data;
                })
                .catch(error => Promise.reject(error))
                .finally(() => {
                    actions.setIsFetchingAllPackages(packagesInitialState.isFetchingAllPackages);
                })
        } else {
            return Promise.resolve();
        }
    }),

    addPackage: action((state, payload) => {
        state.allPackages = [...state.allPackages, payload];
    }),

    createPackage: thunk((actions, payload, helpers) => {
        const { apiData: { ACTIONS } } = helpers.getStoreState().actionSlugs;
        const createPackageUrl = ACTIONS?.packages?.create?.url;

        return axios.post(createPackageUrl, payload?.data)
            .then((newPackage) => {
                actions.addPackage(newPackage);
                return newPackage;
            })
            .catch(error => Promise.reject(error));
    }),

    updatePackageProps: action((state, payload) => {
        const index = state.allPackages.findIndex(pkg => pkg.uniqueId === payload.uniqueId);
        if (index !== -1) {
            const { clients, ...packageProps } = payload;
            state.allPackages[index] = { ...state.allPackages[index], ...packageProps };
        }
        if (state.packageById?.uniqueId === payload.uniqueId) {
            state.packageById = { ...state.packageById, ...payload };
        }
    }),

    updatePackage: thunk((actions, payload, helpers) => {
        const { data, uniqueId } = payload;

        const { apiData: { ACTIONS } } = helpers.getStoreState().actionSlugs;
        const updatePackageUrl = ACTIONS?.packages?.update?.url?.replace('uniqueId', uniqueId);

        return axios.post(updatePackageUrl, data)
            .then((updatedPackage) => {
                actions.updatePackageProps(updatedPackage);
                return updatedPackage;
            })
            .catch(error => Promise.reject(error));
    }),

    // handlingOnePackage
    setPackageById: action((state, payload) => {
        state.packageById = payload;
    }),
    setIsFetchingOnePackage: action((state, payload) => {
        state.isFetchingOnePackage = payload;
    }),

    fetchPackageById: thunk((actions, payload, helpers) => {
        const { isFetchingOnePackage } = helpers.getState();
        const { apiData: { ACTIONS } } = helpers.getStoreState().actionSlugs;

        const getUrl = ACTIONS?.packages?.readOne?.url?.replace('uniqueId', payload);

        if (!isFetchingOnePackage) {
            actions.setIsFetchingOnePackage(true);
            actions.setPackageById(packagesInitialState.packageById);
            return axios.get(getUrl)
                .then(data => {
                    actions.setIsFetchingOnePackage(packagesInitialState.isFetchingOnePackage);
                    actions.setPackageById(data);
                    return data;
                })
                .catch(error => Promise.reject(error))
        } else {
            return Promise.resolve();
        }
    }),


    updatePackageApks: action((state, payload) => {
        if (state.packageById?.uniqueId === payload.packageUniqueId) {
            state.packageById.apks = state.packageById.apks || [];

            const index = state.packageById.apks.findIndex(a => a.uniqueId === payload.uniqueId);
            if (index === -1) {
                state.packageById.apks.push(payload);
            } else {
                state.packageById.apks[index] = { ...state.packageById.apks[index], ...payload };
            }
        }
    })


};

export default packages;